// extracted by mini-css-extract-plugin
export default {"logoImage":"styles_logoImage__Hpy7H","title":"styles_title__qQQtu","line":"styles_line__A7pFH","backButton":"styles_backButton__np8fQ"};